import { render } from "./EditReminder.vue?vue&type=template&id=15eff97c"
import script from "./EditReminder.vue?vue&type=script&lang=js"
export * from "./EditReminder.vue?vue&type=script&lang=js"

import "./EditReminder.vue?vue&type=style&index=0&id=15eff97c&lang=css"
import "./EditReminder.vue?vue&type=style&index=1&id=15eff97c&lang=css"

import exportComponent from "E:\\Sources\\Repos\\TaskApi\\TaskApp.VueCore\\clientTaskApp\\clientTaskApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__